import { defineStore } from 'pinia';
import { WallStructureDTORowKeyEnum } from '~/api/webservice/index';
import { thresholdsAPI } from '~/APIConnection';

import { ISOPROHeight, CatAThreshold } from '~/models';

/** */
export const useThresholdsStore = defineStore('thresholds', {
  state: () => {
    return {
      /** */
      catAThresholds: new Map<CatAThreshold['height'], CatAThreshold>(),
    };
  },
  actions: {
    /** */
    getCatAByWallStructure (height: ISOPROHeight, wallStructureType: WallStructureDTORowKeyEnum): number | null {
      const catA = this.catAThresholds.get(height);
      return catA?.[wallStructureType] || null;
    },
    /** */
    async fetchThresholds (): Promise<void> {
      const API = thresholdsAPI;
      const { data } = await API.thresholdsControllerGetCatAThresholds();
      data.forEach((c) => {
        const cat = new CatAThreshold(c);
        this.catAThresholds.set(cat.height, cat);
      });
    }
  }
});
